/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { LanguageDto } from '../models/language-dto';
import { localizationLanguagesGet$Json } from '../fn/localization/localization-languages-get-json';
import { LocalizationLanguagesGet$Json$Params } from '../fn/localization/localization-languages-get-json';
import { localizationLanguagesGet$Plain } from '../fn/localization/localization-languages-get-plain';
import { LocalizationLanguagesGet$Plain$Params } from '../fn/localization/localization-languages-get-plain';
import { localizationTranslateGet$Json } from '../fn/localization/localization-translate-get-json';
import { LocalizationTranslateGet$Json$Params } from '../fn/localization/localization-translate-get-json';
import { localizationTranslateGet$Plain } from '../fn/localization/localization-translate-get-plain';
import { LocalizationTranslateGet$Plain$Params } from '../fn/localization/localization-translate-get-plain';
import { localizationUserUserIdLanguagePost } from '../fn/localization/localization-user-user-id-language-post';
import { LocalizationUserUserIdLanguagePost$Params } from '../fn/localization/localization-user-user-id-language-post';

@Injectable({ providedIn: 'root' })
export class LocalizationApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `localizationLanguagesGet()` */
  static readonly LocalizationLanguagesGetPath = '/localization/languages';

  /**
   * List languages.
   *
   * Returns list of supported UI languages.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `localizationLanguagesGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  localizationLanguagesGet$Plain$Response(params?: LocalizationLanguagesGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageDto>>> {
    const obs = localizationLanguagesGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List languages.
   *
   * Returns list of supported UI languages.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `localizationLanguagesGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  localizationLanguagesGet$Plain(params?: LocalizationLanguagesGet$Plain$Params, context?: HttpContext): Observable<Array<LanguageDto>> {
    const resp = this.localizationLanguagesGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<LanguageDto>>): Array<LanguageDto> => r.body)
    );
  }

  /**
   * List languages.
   *
   * Returns list of supported UI languages.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `localizationLanguagesGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  localizationLanguagesGet$Json$Response(params?: LocalizationLanguagesGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<LanguageDto>>> {
    const obs = localizationLanguagesGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * List languages.
   *
   * Returns list of supported UI languages.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `localizationLanguagesGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  localizationLanguagesGet$Json(params?: LocalizationLanguagesGet$Json$Params, context?: HttpContext): Observable<Array<LanguageDto>> {
    const resp = this.localizationLanguagesGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<LanguageDto>>): Array<LanguageDto> => r.body)
    );
  }

  /** Path part for operation `localizationUserUserIdLanguagePost()` */
  static readonly LocalizationUserUserIdLanguagePostPath = '/localization/user/{userId}/language';

  /**
   * Set user language.
   *
   * Sets the preferred language for a user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `localizationUserUserIdLanguagePost()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  localizationUserUserIdLanguagePost$Response(params: LocalizationUserUserIdLanguagePost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = localizationUserUserIdLanguagePost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Set user language.
   *
   * Sets the preferred language for a user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `localizationUserUserIdLanguagePost$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  localizationUserUserIdLanguagePost(params: LocalizationUserUserIdLanguagePost$Params, context?: HttpContext): Observable<void> {
    const resp = this.localizationUserUserIdLanguagePost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `localizationTranslateGet()` */
  static readonly LocalizationTranslateGetPath = '/localization/translate';

  /**
   * Get translation.
   *
   * Returns a single translation for language/scope/key.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `localizationTranslateGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  localizationTranslateGet$Plain$Response(params?: LocalizationTranslateGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = localizationTranslateGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get translation.
   *
   * Returns a single translation for language/scope/key.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `localizationTranslateGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  localizationTranslateGet$Plain(params?: LocalizationTranslateGet$Plain$Params, context?: HttpContext): Observable<string> {
    const resp = this.localizationTranslateGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * Get translation.
   *
   * Returns a single translation for language/scope/key.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `localizationTranslateGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  localizationTranslateGet$Json$Response(params?: LocalizationTranslateGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = localizationTranslateGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Get translation.
   *
   * Returns a single translation for language/scope/key.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `localizationTranslateGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  localizationTranslateGet$Json(params?: LocalizationTranslateGet$Json$Params, context?: HttpContext): Observable<string> {
    const resp = this.localizationTranslateGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
